import { CSSObject } from '@emotion/react';
import { theme } from 'styles';

const { color, radius } = theme;

const row: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  padding: '14px 16px',
  borderBottom: `1px solid ${color.grey75}`,
  ':last-of-type': {
    borderBottom: 'none',
  },
};

const image: CSSObject = {
  flex: 'none',
  width: 48,
  height: 48,
  borderRadius: radius.md,
  background: color.grey50,
  objectFit: 'contain',
};

const info: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  flex: 1,
  minWidth: 0,
};

const name: CSSObject = {
  fontSize: 15,
  fontWeight: 600,
  color: color.text,
  wordBreak: 'break-all',
  span: {
    marginLeft: 4,
    fontWeight: 400,
    color: color.textSub,
  },
};

const meta: CSSObject = {
  fontSize: 13,
  color: color.textSub,
  wordBreak: 'keep-all',
  overflowWrap: 'anywhere',
};

const action: CSSObject = {
  flex: 'none',
  height: 34,
  padding: '0 14px',
};

const actions: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: 6,
  flex: 'none',
};

const sheet: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  width: 500,
  maxWidth: '100%',
};

const sheetList: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
};

const tabs: CSSObject = {
  display: 'flex',
  gap: 4,
  padding: 4,
  borderRadius: radius.md,
  background: color.grey75,
};

const tab = (active: boolean): CSSObject => ({
  flex: 1,
  height: 36,
  borderRadius: radius.sm,
  fontSize: 14,
  fontWeight: active ? 700 : 500,
  color: active ? color.text : color.grey500,
  background: active ? color.white : 'transparent',
  boxShadow: active ? theme.shadow.card : 'none',
  cursor: 'pointer',
});

const groupHead: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
  padding: '10px 12px',
  borderRadius: radius.md,
  background: color.grey50,
  fontSize: 14,
  strong: {
    fontWeight: 700,
    color: color.text,
  },
  span: {
    marginLeft: 6,
    color: color.textSub,
  },
};

const submit: CSSObject = {
  width: '100%',
  height: 48,
};

export {
  row,
  image,
  info,
  name,
  meta,
  action,
  actions,
  sheet,
  sheetList,
  tabs,
  tab,
  groupHead,
  submit,
};
